import { render, staticRenderFns } from "./checkbox-filter.vue?vue&type=template&id=56f3241c"
import script from "./checkbox-filter.vue?vue&type=script&lang=ts"
export * from "./checkbox-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports